import { AxiosMethods, ContactsApi } from '@setvi/shared/enums';
import { axiosHelper } from '@setvi/shared/services';
import { Contact } from '@setvi/shared/services/react-query/query/contacts/types';

export enum ContactsMutationsKey {
  ADD_CONTACTS = 'add_contacts',
  UPDATE_CONTACTS = 'update_contacts',
  DELETE_CONTACTS = 'delete_contacts',
  CREATE_NOTE = 'create_note',
  UPDATE_NOTE = 'update_note',
  DELETE_NOTE = 'delete_note'
}

export type ContactValues = Pick<
  Contact,
  'Email' | 'FirstName' | 'LastName' | 'CompanyName' | 'Title' | 'Phone'
>;

interface CreateContactsMutationProps {
  contacts: ContactValues[];
  ignoreDuplicates?: boolean;
}

export const createContactsMutation = () => ({
  mutationFn: ({
    contacts,
    ignoreDuplicates = false
  }: CreateContactsMutationProps) =>
    axiosHelper({
      endpoint: ContactsApi.Contacts,
      method: AxiosMethods.POST,
      body: { Contacts: contacts, IgnoreDuplicates: ignoreDuplicates },
      baseURL: process.env.ADMIN_API_BASE_URL
    }).then(res => res?.Data)
});

export type UpdateContactValues = Pick<
  Contact,
  'Id' | 'Email' | 'FirstName' | 'LastName' | 'CompanyName' | 'Title' | 'Phone'
>;

interface UpdateContactsMutationProps {
  contacts: UpdateContactValues[];
  ignoreDuplicates?: boolean;
}

export const updateContactsMutation = () => ({
  mutationFn: ({
    contacts,
    ignoreDuplicates = false
  }: UpdateContactsMutationProps) =>
    axiosHelper({
      endpoint: ContactsApi.Contacts,
      method: AxiosMethods.PUT,
      body: { Contacts: contacts, IgnoreDuplicates: ignoreDuplicates },
      baseURL: process.env.ADMIN_API_BASE_URL
    }).then(res => res?.Data)
});

interface DeleteContactsMutationProps {
  contactIds: Contact['Id'][];
}

export const deleteContactsMutation = () => ({
  mutationFn: ({ contactIds }: DeleteContactsMutationProps) =>
    axiosHelper({
      endpoint: ContactsApi.Contacts,
      method: AxiosMethods.DELETE,
      body: { IDs: contactIds },
      baseURL: process.env.ADMIN_API_BASE_URL
    }).then(res => res?.Data)
});

interface ImportFromFilestackMutationProps {
  handle: string;
  groupName?: string;
}

export const importFromFilestackMutation = () => ({
  mutationFn: ({ handle, groupName }: ImportFromFilestackMutationProps) =>
    axiosHelper({
      endpoint: ContactsApi.ImportFromFilestack,
      method: AxiosMethods.POST,
      body: { handle, GroupName: groupName || '' },
      baseURL: process.env.ADMIN_API_BASE_URL
    }).then(res => res?.Data)
});

interface CreateNoteMutationProps {
  Text: string;
  UserContactId: number;
}

export const createNoteMutation = () => ({
  mutationFn: (props: CreateNoteMutationProps) =>
    axiosHelper({
      endpoint: ContactsApi.ContactNote,
      method: AxiosMethods.POST,
      body: props,
      baseURL: process.env.ADMIN_API_BASE_URL
    }).then(res => res?.Data)
});

interface UpdateNoteMutationProps {
  Id: number;
  Text: string;
}

export const updateNoteMutation = () => ({
  mutationFn: (props: UpdateNoteMutationProps) =>
    axiosHelper({
      endpoint: ContactsApi.ContactNote,
      method: AxiosMethods.PUT,
      body: props,
      baseURL: process.env.ADMIN_API_BASE_URL
    }).then(res => res?.Data)
});

interface DeleteNoteMutationProps {
  id: number;
}

export const deleteNoteMutation = () => ({
  mutationFn: ({ id }: DeleteNoteMutationProps) =>
    axiosHelper({
      endpoint: ContactsApi.ContactNoteById.replace(':id', id.toString()),
      method: AxiosMethods.DELETE,
      baseURL: process.env.ADMIN_API_BASE_URL
    }).then(res => res?.Data)
});
